<svelte:head>
  <title>Create charity | A Good Thing</title>
</svelte:head>

<div class="block is-size-7"><a href={$url('.')}> &lt; Back to charities</a></div>

<h2 class="title">Add new charity</h2>

<article class="message is-success">
  <div class="message-body">
    <p>
      Use this form to register a new user and charity. A sign-up link will be
      created.
    </p>
  </div>
</article>

{#if showToast}
  <div class="notification is-success">
    <button class="delete" on:click={() => (showToast = false)} />
    User and charity added
  </div>
{/if}
<hr />
<h2 class="is-size-4">User</h2>

<!-- New or existing -->

<div class="field has-addons">
  <div class="control">
    <div class="select">
      <select bind:value={userType}>
        <option value={'new'}>New</option>
        <option value={'existing'}>Existing</option>
      </select>
    </div>
  </div>
</div>

{#if userType === 'new'}
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label for="email" class="label">Email (required)</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input
            id="email"
            class="input"
            type="text"
            placeholder=""
            bind:value={email}
          />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label for="firstName" class="label">First name</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input
            id="firstName"
            class="input"
            type="text"
            placeholder=""
            bind:value={user.firstName}
          />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label for="lastName" class="label">Last name</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input
            id="lastName"
            class="input"
            type="text"
            placeholder=""
            bind:value={user.lastName}
          />
        </div>
      </div>
    </div>
  </div>
{:else}
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label for="email" class="label">Email</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input
            id="email"
            class="input"
            type="text"
            placeholder=""
            bind:value={email}
          />
        </div>
      </div>
    </div>
  </div>
{/if}

<hr />

<h2 class="is-size-4">Charity</h2>

<!-- type -->
<div class="field has-addons">
  <div class="control">
    <div class="select">
      <select bind:value={charityType}>
        <option value={'ScotlandRegistered'}>Scottish registered</option>
        <option value={'Unregistered'}>Unregistered</option>
      </select>
    </div>
  </div>
</div>

{#if charityType === 'ScotlandRegistered'}
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label for="name" class="label">Number</label>
    </div>
    <div class="field-body">
      <div class="field is-horizontal">
        <div class="control">
          <input
            id="name"
            class="input"
            type="text"
            placeholder=""
            bind:value={scotlandCharityInfo.charityNumber}
          />
        </div>
      </div>
    </div>
  </div>
{/if}

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="name" class="label">Name (required)</label>
  </div>
  <div class="field-body">
    <div class="field is-horizontal">
      <div class="control">
        <input
          id="name"
          class="input"
          type="text"
          placeholder=""
          bind:value={name}
        />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="website" class="label">Website</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input
          id="website"
          class="input"
          type="text"
          placeholder=""
          bind:value={website}
        />
      </div>
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="description" class="label">Description</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <textarea
          id="description"
          class="textarea"
          placeholder=""
          rows="10"
          bind:value={description}
        />
      </div>
    </div>
  </div>
</div>

{#if !selectedAddress}
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label for="postcode" class="label">Postcode</label>
    </div>
    <div class="field-body">
      <div class="field has-addons">
        <div class="control is-expanded">
          <input
            id="postcode"
            class="input"
            type="text"
            placeholder=""
            bind:value={postcode}
          />
        </div>
        <div class="control">
          <button
            class="button"
            on:click={lookup}
            class:is-loading={isLoadingLookup}>Find</button
          >
        </div>
      </div>
    </div>
  </div>

  {#if addresses}
    <div class="block">
      <p><b>Select address</b></p>
      {#each addresses as address}
        <div style="overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">
          <!-- svelte-ignore a11y-missing-attribute -->
          <a
            on:click={() => {
              selectedAddress = address;
            }}>{address.summaryline}</a
          >
        </div>
      {/each}
    </div>
  {/if}
{/if}

{#if selectedAddress}
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label for="addressline1" class="label">First line</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input
            id="addressline1"
            class="input"
            type="text"
            placeholder=""
            bind:value={selectedAddress.addressline1}
          />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label for="addressline2" class="label">Second line</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input
            id="addressline2"
            class="input"
            type="text"
            placeholder=""
            bind:value={selectedAddress.addressline2}
          />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label for="town" class="label">Town</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input
            id="town"
            class="input"
            type="text"
            placeholder=""
            bind:value={selectedAddress.posttown}
          />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label for="postcode" class="label">Postcode</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input
            id="postcode"
            class="input"
            type="text"
            placeholder=""
            bind:value={selectedAddress.postcode}
          />
        </div>
      </div>
    </div>
  </div>
{/if}
<hr />
<div class="field is-horizontal">
  <div class="field-label">
    <!-- Left empty for spacing -->
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <button
          class:is-loading={isLoading}
          class="button is-primary"
          on:click={() => submit()}>Save</button
        >
      </div>
    </div>
  </div>
</div>

{#if errorMessage}
  <div class="block">
    <div class="notification is-danger is-light">
      {errorMessage}
    </div>
  </div>
{/if}

<script lang="ts">
  import { goto, url } from '@sveltech/routify';
  import _ from 'lodash';
  import { logging } from '../../../lib/logging';

  let showToast = false;

  let firebase = window.firebase;

  let userType: 'new' | 'existing' = 'new';

  let user = {
      firstName: undefined,
      lastName: undefined,
      charity: undefined,
    },
    email: string;

  let name: string, website: string, description: string, postcode: string;

  let charityType: CharityType = 'Unregistered';

  let scotlandCharityInfo = {
    charityNumber: '',
  };

  let addresses: FullAddress[];

  let selectedAddress: FullAddress;

  let isLoading: boolean, isLoadingLookup: boolean;
  let errorMessage: string;

  async function submit() {
    isLoading = true;

    let address;

    if (selectedAddress) {
      address = [
        selectedAddress?.addressline1,
        selectedAddress?.addressline2,
        '',
        selectedAddress?.posttown,
      ];
    } else {
      address = ['', '', '', ''];
    }

    let charity: Charity_v2 = {
      created: "",
      type: charityType,
      name: name,
      location: undefined,
      website: website,
      contact: {
        email: '',
        phone: '',
        postcode: postcode,
        address: address,
        social: [],
      },
      description: description,
      domains: [],
      image: undefined,
      info: {
        name: name,
        charityNumber: scotlandCharityInfo.charityNumber,
      },
    };

    try {
      const lowercaseEmail = email.toLowerCase();

      const existingUser = await firebase
        .firestore()
        .doc('users_v1/' + lowercaseEmail)
        .get();

      if (userType === 'new' && existingUser.exists) {
        throw new Error('User already exists');
      }

      if (userType === 'existing' && !existingUser.exists) {
        throw new Error('User does not exist');
      }

      if (
        userType === 'existing' &&
        existingUser.exists &&
        existingUser.data()!.charity
      ) {
        throw new Error('User already assigned to charity');
      }

      const result = await firebase.functions().httpsCallable('api-account-createcharity')({
        charity,
      } as CreateCharityParams);

      if (userType === 'new') {
        user.charity = result.data.id;
        await firebase
          .firestore()
          .doc('users_v1/' + lowercaseEmail)
          .set(user);
      } else {
        await firebase
          .firestore()
          .doc('users_v1/' + lowercaseEmail)
          .update({
            charity: result.data.id,
          });
      }

      $goto('../' + result.data.id);

      showToast = true;
    } catch (err: any) {
      errorMessage = err.toString();
      logging.report(err.toString());
    }

    isLoading = false;
  }

  async function lookup() {
    isLoadingLookup = true;

    const apiKey = 'PCWNV-535F5-P59NX-P5G2A';
    const country = 'UK';

    fetch(
      `https://ws.postcoder.com/pcw/${apiKey}/address/${country}/${encodeURIComponent(
        postcode
      )}?format=json&lines=2&identifier=business_setup`
    )
      .then((response) => {
        return response.json();
      })
      .then(
        (data) => {
          isLoadingLookup = false;
          console.log(data);
          addresses = data;
        },
        (error) => {
          isLoadingLookup = false;
          console.log(error);
        }
      );
  }
</script>
